import { gql } from "@apollo/client";
import { storeInformation } from "../../fragments";

export const GET_BOOKABLE_STORE = gql`
  query BookableStore($id: ID!, $first: Int = 100) {
    store: node(id: $id) {
      ... on Store {
        ...storeInformation
        appointmentsEnabled
        serviceTypes {
          id
          name
          type
          categories {
            id
            name
            icon {
              selectedUrl
              unselectedUrl
            }
            services {
              id
              name
              description
              icon {
                selectedUrl
                unselectedUrl
              }
            }
          }
        }
        artists(first: $first) {
          edges {
            node {
              id
              services
              person {
                id
                name
              }
            }
          }
        }
      }
    }
  }
  ${storeInformation}
`;

export const AVAILABLE_APPOINTMENT_SLOTS = gql`
  query AvailableAppointmentSlots(
    $storeId: ID!
    $serviceId: ID!
    $employeeId: ID
    $date: Date!
    $durationMinutes: Int!
  ) {
    availableAppointmentSlots(
      storeId: $storeId
      serviceId: $serviceId
      employeeId: $employeeId
      date: $date
      durationMinutes: $durationMinutes
    ) {
      startsAt
      availableEmployeeIds
    }
  }
`;

export const CREATE_PUBLIC_APPOINTMENT = gql`
  mutation CreatePublicAppointment($input: CreatePublicAppointmentInput!) {
    result: createPublicAppointment(input: $input) {
      visit {
        id
        scheduledFor
        status
      }
      errors {
        field
        message
      }
    }
  }
`;
